<div class="grid-container padding-y-4">
  <div class="grid-row">
    <div class="grid-col-8">
      <legend class="usa-legend usa-legend--large">TSP Approval</legend>
      @if (carrier) {
        <legend class="usa-legend usa-legend--medium">{{carrier.scac}} - {{carrier.scacName}}
          @if (isReadOnly) {
            <span class="text-danger">- Revoked</span>
          }</legend>
        }
      </div>
      <div class="grid-col-4">
        @if (isHhgCarrier || isBothCarrier) {
          <button class="usa-button usa-button--outline" (click)="goToHHgScope()">
            Define Scope
          </button>
        }
        <button class="usa-button usa-button--outline" (click)="gotToCarrierProfile()">Profile</button>
        <button class="usa-button usa-button--outline" routerLink="/agencytspsearch">Search</button>
      </div>
    </div>
    <div class="grid-row">
      @if (saveSuccessful) {
        <div class="usa-alert usa-alert--success usa-alert--no-icon">
          <div class="usa-alert__body">
            <p class="usa-alert__text">
              TSP Approval Information has been updated successfully
            </p>
          </div>
        </div>
      }
    </div>
    <form [formGroup]="carrierApprovalForm">
      <fieldset class="usa-fieldset">
        <div class="grid-row grid-gap-1">
          <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-3 desktop:grid-col-3">
            <label for="type" class="usa-label">Approval Type</label>
            <select id="type" class="usa-select" formControlName="approvalType" (change)="changeApprovalType($event)">
              @if (isHhgCarrier || isBothCarrier) {
                <option value='Domestic HHG'>HHG Domestic</option>
              }
              @if (isHhgCarrier || isBothCarrier) {
                <option value='International HHG'>HHG International</option>
              }
              @if (isHhgCarrier || isBothCarrier) {
                <option value='HHG Rate Filing Service'>HHG Rate Filing Service</option>
              }
              <!-- <option *ngIf="isHhgCarrier || isBothCarrier" value = 'OFM Vehicles' >OFM Vehicles</option>-->
              @if (isHhgCarrier || isBothCarrier) {
                <option value='Extended Storage HHG'>HHG Extended Storage</option>
              }
              @if (isFreightCarrier || isBothCarrier) {
                <option value='Domestic FRT'>Freight TSP</option>
              }
              <!--<option *ngIf="isFreightCarrier || isBothCarrier" value = 'Freight Rate Filing Service' >Freight Rate Filing Service</option>-->
            </select>
          </div>
          @if ((this.carrierApprovalForm.value.approvalType==="Domestic HHG") || (this.carrierApprovalForm.value.approvalType==="International HHG")) {
            <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-3 desktop:grid-col-3">
              <label for="type" class="usa-label">US DOT @if (this.carrierApprovalForm.value.approvalType==='Domestic HHG') {
                <abbr title="required" class="usa-hint usa-hint--required">*</abbr>
              }</label>
              <input type="text" formControlName="usDot" id="usDot" class="usa-input" maxlength="12" placeholder="US DOT Number" [readonly]='isReadOnly'>
              @if (usDot.invalid && (usDot.dirty || usDot.touched) && (this.approvalType==='Domestic HHG')) {
                <div>
                  @if (usDot.errors?.required) {
                    <small class="define-text-secondary">
                      <svg class="usa-icon" aria-hidden="true" focusable="false" role="img">
                        <use xlink:href="/assets/uswds/img/sprite.svg#warning"></use>
                      </svg>USDOT Number is required
                    </small>
                  }
                </div>
              }
              @if (usDot.invalid && (usDot.dirty || usDot.touched)) {
                <div>
                  @if (usDot.errors?.minlength || usDot.errors?.maxlength) {
                    <small class="define-text-secondary">
                      <svg class="usa-icon" aria-hidden="true" focusable="false" role="img">
                        <use xlink:href="/assets/uswds/img/sprite.svg#warning"></use>
                      </svg>USDOT must be 12 characters
                    </small>
                  }
                </div>
              }
              @if (usDot.invalid && (usDot.dirty || usDot.touched)) {
                <div>
                  @if (usDot.errors?.pattern) {
                    <small class="define-text-secondary">
                      <svg class="usa-icon" aria-hidden="true" focusable="false" role="img">
                        <use xlink:href="/assets/uswds/img/sprite.svg#warning"></use>
                      </svg>USDOT only has numbers
                    </small>
                  }
                </div>
              }
            </div>
          }
          @if ((this.carrierApprovalForm.value.approvalType==="Domestic HHG")) {
            <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-3 desktop:grid-col-3">
              <label for="type" class="usa-label"> &#8203; </label>
              <div class="usa-checkbox">
                <input
                  class="usa-checkbox__input" [readonly]='isReadOnly'
                  id="intraState-Scope"
                  type="checkbox" formControlName="intraStateScope" (change)="onIntraStateScope($event)"/>
                <label class="usa-checkbox__label" for="intraState-Scope">Approved for Intrastate Scope Only</label>
              </div>
            </div>
          }

        </div>

        @if ((this.carrierApprovalForm.value.approvalType==="Domestic HHG") || (this.carrierApprovalForm.value.approvalType==="International HHG")) {
          <div class="grid-row grid-gap-1">
            <legend class="usa-legend usa-legend--small text-bold">Data must be entered for at least one of the following fields.
              @if ((this.carrierApprovalForm.value.approvalType==="Domestic HHG")) {
                <span>
                  unless “Approved for Intrastate Scope Only” is checked
                </span>
              }
            </legend>
          </div>
        }
        <div class="grid-row grid-gap-1">
          @if ((this.carrierApprovalForm.value.approvalType==="International HHG")) {
            <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-3 desktop:grid-col-3">
              <label for="type" class="usa-label">FMC OTI</label>
              <input type="text" formControlName="fmcOTI" id="fmcOTI" class="usa-input" maxlength="12" placeholder="FMC OTI Number" [readonly]='isReadOnly'>
              @if ((this.carrierApprovalForm.hasError('oneOfThreeHasValue')) && (this.approvalType==='International HHG')) {
                <div>
                  <small class="define-text-secondary">
                    <svg class="usa-icon" aria-hidden="true" focusable="false" role="img">
                      <use xlink:href="/assets/uswds/img/sprite.svg#warning"></use>
                    </svg>FMC OTI#, MC# or FF# must be entered
                  </small>
                </div>
              }
              @if (fmcOTI.invalid && (fmcOTI.dirty || fmcOTI.touched)) {
                <div>
                  @if (fmcOTI.errors?.minlength || fmcOTI.errors?.maxlength) {
                    <small class="define-text-secondary">
                      <svg class="usa-icon" aria-hidden="true" focusable="false" role="img">
                        <use xlink:href="/assets/uswds/img/sprite.svg#warning"></use>
                      </svg>FMC OTI must be 12 characters
                    </small>
                  }
                </div>
              }
              @if (fmcOTI.invalid && (fmcOTI.dirty || fmcOTI.touched)) {
                <div>
                  @if (fmcOTI.errors?.pattern) {
                    <small class="define-text-secondary">
                      <svg class="usa-icon" aria-hidden="true" focusable="false" role="img">
                        <use xlink:href="/assets/uswds/img/sprite.svg#warning"></use>
                      </svg>FMC OTI only has numbers
                    </small>
                  }
                </div>
              }
            </div>
          }

          @if ((this.carrierApprovalForm.value.approvalType==="Domestic HHG") || (this.carrierApprovalForm.value.approvalType==="International HHG")) {
            <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-3 desktop:grid-col-3">
              <label class="usa-label">Motor Common Carrier Authority</label>
              <input maxlength="12" id="mcNumber" class="usa-input" formControlName="inputMCNumber" type="tel" placeholder="MC Number" [readonly]='isReadOnly'>
              @if ((this.carrierApprovalForm.hasError('oneOfThreeHasValue')) && (this.approvalType==='International HHG')) {
                <div>
                  <small class="define-text-secondary">
                    <svg class="usa-icon" aria-hidden="true" focusable="false" role="img">
                      <use xlink:href="/assets/uswds/img/sprite.svg#warning"></use>
                    </svg>FMC OTI#, MC# or FF# must be entered
                  </small>
                </div>
              }
              @if (this.carrierApprovalForm.hasError('oneOfTwoHasValue') && approvalType==='Domestic HHG') {
                <div>
                  <small class="define-text-secondary">
                    <svg class="usa-icon" aria-hidden="true" focusable="false" role="img">
                      <use xlink:href="/assets/uswds/img/sprite.svg#warning"></use>
                    </svg>MC Number or FF Number must be entered
                  </small>
                </div>
              }
              @if (inputMCNumber.invalid && (inputMCNumber.dirty || inputMCNumber.touched)) {
                <div>
                  @if (inputMCNumber.errors?.required) {
                    <small class="define-text-secondary">
                      <svg class="usa-icon" aria-hidden="true" focusable="false" role="img">
                        <use xlink:href="/assets/uswds/img/sprite.svg#warning"></use>
                      </svg>MC Number is required
                    </small>
                  }
                </div>
              }
              @if (inputMCNumber.invalid && (inputMCNumber.dirty || inputMCNumber.touched)) {
                <div>
                  @if (inputMCNumber.errors?.minlength || inputMCNumber.errors?.maxlength) {
                    <small class="define-text-secondary">
                      <svg class="usa-icon" aria-hidden="true" focusable="false" role="img">
                        <use xlink:href="/assets/uswds/img/sprite.svg#warning"></use>
                      </svg>MC Number must be 12 characters
                    </small>
                  }
                </div>
              }
              @if (inputMCNumber.invalid && (inputMCNumber.dirty || inputMCNumber.touched)) {
                <div>
                  @if (inputMCNumber.errors?.pattern) {
                    <small class="define-text-secondary">
                      <svg class="usa-icon" aria-hidden="true" focusable="false" role="img">
                        <use xlink:href="/assets/uswds/img/sprite.svg#warning"></use>
                      </svg>MC Number only has numbers
                    </small>
                  }
                </div>
              }
            </div>
          }

          @if ((this.carrierApprovalForm.value.approvalType==="Domestic HHG") || (this.carrierApprovalForm.value.approvalType==="International HHG")) {
            <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-3 desktop:grid-col-3">
              <label class="usa-label" for="ff-number">Freight Forwarder Authority</label>
              <input type="text" id="ffNumber" class="usa-input" formControlName="inputFFNumber" maxlength="12" placeholder="FF Number" [readonly]='isReadOnly'>
              @if ((this.carrierApprovalForm.hasError('oneOfThreeHasValue')) && (this.approvalType==='International HHG')) {
                <div>
                  <small class="define-text-secondary">
                    <svg class="usa-icon" aria-hidden="true" focusable="false" role="img">
                      <use xlink:href="/assets/uswds/img/sprite.svg#warning"></use>
                    </svg>FMC OTI#, MC# or FF# must be entered
                  </small>
                </div>
              }
              @if (this.carrierApprovalForm.hasError('oneOfTwoHasValue') && (approvalType==='Domestic HHG')) {
                <div>
                  <small class="define-text-secondary">
                    <svg class="usa-icon" aria-hidden="true" focusable="false" role="img">
                      <use xlink:href="/assets/uswds/img/sprite.svg#warning"></use>
                    </svg>@if (approvalType==='Domestic HHG') {
                    <span>MC Number or</span>
                    } FF Number must be entered
                  </small>
                </div>
              }
              @if (inputFFNumber.invalid && (inputFFNumber.dirty || inputFFNumber.touched)) {
                <div>
                  @if (inputFFNumber.errors?.required) {
                    <small class="define-text-secondary">
                      <svg class="usa-icon" aria-hidden="true" focusable="false" role="img">
                        <use xlink:href="/assets/uswds/img/sprite.svg#warning"></use>
                      </svg>FF Number is required
                    </small>
                  }
                </div>
              }
              @if (inputFFNumber.invalid && (inputFFNumber.dirty || inputFFNumber.touched)) {
                <div>
                  @if (inputFFNumber.errors?.minlength || inputFFNumber.errors?.maxlength) {
                    <small class="define-text-secondary">
                      <svg class="usa-icon" aria-hidden="true" focusable="false" role="img">
                        <use xlink:href="/assets/uswds/img/sprite.svg#warning"></use>
                      </svg>FF Number must be 12 characters
                    </small>
                  }
                </div>
              }
              @if (inputFFNumber.invalid && (inputFFNumber.dirty || inputFFNumber.touched)) {
                <div>
                  @if (inputFFNumber.errors?.pattern) {
                    <small class="define-text-secondary">
                      <svg class="usa-icon" aria-hidden="true" focusable="false" role="img">
                        <use xlink:href="/assets/uswds/img/sprite.svg#warning"></use>
                      </svg>FF Number only has numbers
                    </small>
                  }
                </div>
              }
            </div>
          }
        </div>
        <hr>
          <div class="grid-row">
            <legend class="usa-legend usa-legend--medium">TSP Information</legend>
          </div>
          <div class="grid-row grid-gap-1">
            <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-3 desktop:grid-col-3">
              <label for="tpa_id" class="usa-label">TPA ID<abbr title="required"
              class="usa-hint usa-hint--required">*</abbr></label>
              <input type="text" id="tpa_id" class="usa-input" formControlName="tpaId" maxlength="6" [readonly]='isReadOnly'>
              @if (this.carrierApprovalForm.get('tpaId').invalid) {
                <div>
                  <small class="define-text-secondary">
                    <svg class="usa-icon" aria-hidden="true" focusable="false" role="img">
                      <use xlink:href="/assets/uswds/img/sprite.svg#warning"></use>
                    </svg>TPA ID is required
                  </small>
                </div>
              }
            </div>
            <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-3 desktop:grid-col-3">
              <label for="tpa_id" class="usa-label">Date Approved<abbr title="required"
              class="usa-hint usa-hint--required">*</abbr></label>
              <input type="text" id="dateApproved" class="usa-input" placeholder="mm/dd/yyyy"
                (bsValueChange)="changeSlider($event, 'approved')" formControlName="dateApproved" name="dateApproved"
                [value]="this.carrierApprovalForm.get('dateApproved').value | date: 'MMM d, y'"
                bsDatepicker
                [bsConfig]="{ dateInputFormat: 'MMM D, YYYY' }"
                placement="right" [maxDate]="maxDate">
              @if (this.carrierApprovalForm.get('dateApproved').invalid) {
                <div>
                  <small class="define-text-secondary">
                    <svg class="usa-icon" aria-hidden="true" focusable="false" role="img">
                      <use xlink:href="/assets/uswds/img/sprite.svg#warning"></use>
                    </svg>Date Approved is required
                  </small>
                </div>
              }
            </div>

            <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-3 desktop:grid-col-3">
              <label for="tsp_csi" class="usa-label">Date Placed in Temporary Non-Use</label>
              <input type="text" id="dateSuspended" class="usa-input" placeholder="mm/dd/yyyy"
                (bsValueChange)="changeSlider($event, 'suspended')" formControlName="dateSuspended"
                [value]="this.carrierApprovalForm.get('dateSuspended').value | date: 'MMM d, y'"
                bsDatepicker
                [bsConfig]="{ dateInputFormat: 'MMM D, YYYY' }"
                [maxDate]="maxDate" placement="right" name="dateSuspended">
              @if (invalidDate) {
                <div>
                  <small class="define-text-secondary">
                    <svg class="usa-icon" aria-hidden="true" focusable="false" role="img">
                      <use xlink:href="/assets/uswds/img/sprite.svg#warning"></use>
                    </svg>Date Suspended must be greater than Date Approved
                  </small>
                </div>
              }
            </div>
          </div>
          <div class="grid-row grid-gap-1">
            <div class="grid-col-2 padding-top-5">
              <label class="switch">
                <input type="checkbox" id="appvedSlider" formControlName="appvedSlider" [readonly]='isReadOnly'>
                <span class="slider round"></span>
              </label>
              <span class="padding-left-2">Approved</span>
            </div>
            @if (showCSI) {
              <div class="grid-col-2">
                <label class="usa-label">Customer Satisfaction Index: {{this.carrierApprovalForm.get('tspCSI').value}}</label>
              </div>
            }
          </div>
          <div class="grid-row grid-gap-1">
            <div class="grid-col-4">
              <label for="approval_notes" class="usa-label">Notes:<abbr title="required" class="usa-hint usa-hint--required">*</abbr>
              <button type="button" class="usa-button margin-left-2"  (click) = "messageHistoryModal()" > Notes History</button>
            </label>
            <textarea id="approval_notes" class="usa-textarea" maxlength="5000"
            formControlName="approvalNotes"></textarea>
          </div>
        </div>
        <hr>
          <div class="grid-row">
            <legend class="usa-legend usa-legend--medium">Socio-Economic Indicators</legend>
          </div>
          <div class="grid-row">
            <fieldset class="usa-fieldset">
              <div class="usa-checkbox">
                <input class="usa-checkbox__input" id="smallbiz" type="checkbox" formControlName="smallBiz" />
                <label class="usa-checkbox__label" for="smallbiz">Small Business (s)</label>
              </div>
              <div class="usa-checkbox">
                <input class="usa-checkbox__input" id="otherThanSmallBiz" type="checkbox" formControlName="otherThanSmallBiz" />
                <label class="usa-checkbox__label" for="otherThanSmallBiz">Other than Small Business (o)</label>
              </div>
              <div class="usa-checkbox">
                <input class="usa-checkbox__input" id="womenBiz" type="checkbox" formControlName="womenBiz"/>
                <label class="usa-checkbox__label" for="womenBiz">Women Owned Business (w)</label>
              </div>
              <div class="usa-checkbox">
                <input class="usa-checkbox__input" id="veteranBiz" type="checkbox" formControlName="veteranBiz"/>
                <label class="usa-checkbox__label" for="veteranBiz">Veteran Owned Small Business (v)</label>
              </div>
              <div class="usa-checkbox">
                <input class="usa-checkbox__input" id="disabledbiz" type="checkbox" formControlName="disabledVetBiz" />
                <label class="usa-checkbox__label" for="disabledbiz">Service Disabled Veteran Owned Small Business (dv)</label>
              </div>
              <div class="usa-checkbox">
                <input class="usa-checkbox__input" id="sbaBiz" type="checkbox" formControlName="sbaBiz" />
                <label class="usa-checkbox__label" for="sbaBiz">SBA Certified Small Disadvantaged Business (d)</label>
              </div>
              <div class="usa-checkbox">
                <input class="usa-checkbox__input" id="firm8a" type="checkbox" formControlName="firm8a"/>
                <label class="usa-checkbox__label" for="firm8a">SBA Certified 8(a) firm (8a)</label>
              </div>
              <div class="usa-checkbox">
                <input class="usa-checkbox__input" id="hubZone" type="checkbox" formControlName="hubZone" />
                <label class="usa-checkbox__label" for="hubZone">SBA Certified HUBZone firm (h)</label>
              </div>
            </fieldset>
          </div>
          <hr>
            @if (showBondInfo) {
              <div class="grid-row grid-gap-1">
                <legend class="usa-legend usa-legend--medium">Bond Information</legend>
              </div>
            }
            @if (showBondInfo) {
              <div class="grid-row grid-gap-1">
                <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-4 desktop:grid-col-4">
                  <label for="bond_no" class="usa-label">Bond Number</label>
                  <input type="text" id="bond_no" class="usa-input" maxlength="20" formControlName="bondNum" [readonly]='isReadOnly'
                    (change)="validateBondInfo()">
                </div>
                <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-4 desktop:grid-col-4">
                  <label for="bond_expire" class="usa-label">Expiration Date</label>
                  <input type="text" id="bond_expire" class="usa-input" placeholder="mm/dd/yyyy"
                    formControlName="bondExpDate" (focus)="onFocusBondDate($event)" (focusout)="onFocusOutBondDate($event)"
                    [value]="this.carrierApprovalForm.get('bondExpDate').value | date: 'MMM d, y'" [minDate]="this.minDate"
                    bsDatepicker
                    [bsConfig]="{ dateInputFormat: 'MMM D, YYYY' }"
                    placement="right">
                  @if (bondReq) {
                    <div>
                      <small class="text-danger">
                        <span class="fa fa-warning"></span> Bond Expiration date is required
                      </small>
                    </div>
                  }
                </div>
              </div>
            }
            @if (showInsure) {
              <div class="grid-row">
                <legend class="usa-legend usa-legend--medium">Insurance Information</legend>
              </div>
            }
            @if (showInsure) {
              <div class="grid-row grid-gap-1">
                <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-4 desktop:grid-col-4">
                  <label for="insur_name" class="usa-label">Insurance Short Name<abbr title="required"
                  class="usa-hint usa-hint--required">*</abbr></label>
                  <input type="text" id="insur_name" class="usa-input" maxlength="4" formControlName="insurName" [readonly]='isReadOnly'
                    (change)="onInsuranceShortNameChange()">
                  @if (insureNameReqd) {
                    <div>
                      <small class="define-text-secondary">
                        <svg class="usa-icon" aria-hidden="true" focusable="false" role="img">
                          <use xlink:href="/assets/uswds/img/sprite.svg#warning"></use>
                        </svg>Insurance Name is required
                      </small>
                    </div>
                  }
                </div>
                @if (isInsuranceShortNamePresent) {
                  <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-4 desktop:grid-col-4">
                    <label for="insur_no" class="usa-label">Insurance Number<abbr title="required"
                    class="usa-hint usa-hint--required">*</abbr></label>
                    <input type="text" id="insur_no" class="usa-input" maxlength="20" formControlName="insurNum" [readonly]='isReadOnly'>
                    @if (this.carrierApprovalForm.get('insurNum').invalid) {
                      <div>
                        <small class="define-text-secondary">
                          <svg class="usa-icon" aria-hidden="true" focusable="false" role="img">
                            <use xlink:href="/assets/uswds/img/sprite.svg#warning"></use>
                          </svg>Insurance Number is required
                        </small>
                      </div>
                    }
                  </div>
                }
                @if (isInsuranceShortNamePresent) {
                  <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-4 desktop:grid-col-4">
                    <label for="insur_expire" class="usa-label">Expiration Date<abbr title="required"
                    class="usa-hint usa-hint--required">*</abbr></label>
                    <input type="text" id="insur_expire" class="usa-input" placeholder="mm/dd/yyyy" formControlName="insurExpDate"
                      [value]="this.carrierApprovalForm.get('insurExpDate').value | date: 'MMM d, y'"
                      [minDate]="this.minDate" bsDatepicker [bsConfig]="datePickerConfig" placement="right">
                    @if (this.carrierApprovalForm.get('insurExpDate').invalid) {
                      <div>
                        <small class="define-text-secondary">
                          <svg class="usa-icon" aria-hidden="true" focusable="false" role="img">
                            <use xlink:href="/assets/uswds/img/sprite.svg#warning"></use>
                          </svg>Insurance Expiration Date is required
                        </small>
                      </div>
                    }
                  </div>
                }
              </div>
            }
            <div class="grid-row margin-top-4">
              <ul class="usa-button-group">
                @if (!isReadOnly) {
                  <li class="usa-button-group__item">
                    <button type="button" class="usa-button"
                      [disabled]="carrierApprovalForm.invalid || saveSuccessful || invalidDate"
                      (click)="saveCarrierApproval();">Save
                    </button>
                  </li>
                }
                <li class="usa-button-group__item">
                  <button type="button" class="usa-button" (click)="viewAuditTrial()">View Audit Trail</button>
                </li>
                @if (this.enableRevokeBtn && !this.isReadOnly) {
                  <li class="usa-button-group__item">
                    <button type="button" class="usa-button" [disabled]="this.carrierApprovalForm.get('approvalNotes').value === ''"
                    (click)="deleteCarrierData()">Revoke {{carrierApprovalForm.get('approvalType').value}} Only</button>
                  </li>
                }
                @if (isReadOnly) {
                  <li class="usa-button-group__item">
                    <button type="button" class="usa-button"
                      [disabled]="this.carrierApprovalForm.get('approvalNotes').value === ''"
                    (click)="reinstateApproval()">Reinstate {{carrierApprovalForm.get('approvalType').value}}</button>
                  </li>
                }
              </ul>
            </div>
          </fieldset>
        </form>
      </div>
